import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './cpr-result.actions';
import { CprResultState } from './cpr-result.state';

/**
 * cprResult initial state
 */
export const cprResultInitialState: CprResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for CprResult Store
 */
export const cprResultReducerFeatures: ReducerTypes<CprResultState, ActionCreator[]>[] = [
  on(actions.setCprResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateCprResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetCprResult, () => cprResultInitialState),

  on(actions.cancelCprResultRequest, (state, action) => asyncStoreItemAdapter.resolveRequest(state, action.requestId)),

  on(actions.failCprResult, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setCprResultFromApi, actions.updateCprResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * CprResult Store reducer
 */
export const cprResultReducer = createReducer(cprResultInitialState, ...cprResultReducerFeatures);
